<style src="summernote/dist/summernote.css"></style>
<style src="codemirror/lib/codemirror.css"></style>
<style src="codemirror/theme/monokai.css"></style>

<style lang="scss">
    .note-editor.note-frame {
        margin: 0;
        border: 1px solid #E3E3E3!important;
        border: solid 1px #ddd;
        box-shadow: none;
        border-radius: 3px;

        .note-toolbar {
            z-index: 5;
        }

        .btn-default {
            background-color: #fff!important;
            border: 1px solid #e3e3e3 !important;
            color: #4E5869!important;
        }

        .note-editing-area .note-editable {
            min-height: 200px;
            height: auto;
            border-top: solid 1px #ddd;
            font-family: Arial, sans-serif;
            font-size: 14px;

            p {
                margin-bottom: 10px;
            }

            b, strong, h1, h2, h3, h4, h5, h6 {
                font-weight: 600;
            }

            h1 {
                font-size: 2em;
                margin: 0.67em 0;
            }

            h2 {
                font-size: 1.5em;
                margin: 0.83em 0;
            }

            h3 {
                font-size: 1.17em;
                margin: 1.0em 0;
            }

            h4 {
                font-size: 1em;
                margin: 1.33em 0;
            }

            h5 {
                font-size: 0.83em;
                margin: 1.67em 0;
            }

            h6 {
                font-size: 0.67em;
                margin: 2.33em 0;
            }

            p, h1, h2, h3, h4, h5, h6 {
                font-family: Arial, sans-serif;
            }

            .table.table-bordered {
                border: dashed 1px #eee !important;

                tbody tr td,
                thead tr th {
                    border: dashed 1px #eee !important;
                }
            }
        }
    }

    .form-group.note-group-select-from-files {
        display: none;
    }

    .form-group.note-group-image-url {
        padding: 20px;
        margin: 0;
    }

    .note-image-btn,
    .note-link-btn {
        margin: 0 15px 15px;
    }

    .link-dialog {
        .modal-dialog .modal-content .modal-body {
            padding: 20px!important;
        }

        .checkbox label input[type="checkbox"] {
            opacity: 1;
            appearance: none;
            -webkit-appearance: none;

            &:checked:after {
                content: "\F00C";
                font-family: 'FontAwesome';
                color: #555555;
                display: inline-block;
                font-size: 12px;
                position: absolute;
                top: -1px;
                left: -2px;
            }
        }
    }
</style>

<template>
    <div class="clearfix">
        <textarea ref="editor"></textarea>
        <p class="show m-t-10" v-if="showDealBtn || showMemberBtn || showCompanyBtn"><i class="fa fa-lightbulb-o"></i> <b>{{ $t('tip') }}:</b> {{ $t('the_use_lead_information_to_compose_the_message_by_clicking_the_lead_info_button') }}</p>
    </div>
</template>

<script>
    import 'summernote'
    import SummernoteImageAttributes from 'assets/vendor/summernote-image-attributes'
    import { trans } from 'utils/helpers/translation'
    import { union } from 'lodash'

    export default {
        data () {
            return {
                editor: null
            }
        },
        props: {
            'value': {
                default: () => ''
            },
            'showDealBtn': {
                type: Boolean,
                default: () => false
            },
            'showMemberBtn': {
                type: Boolean,
                default: () => false
            },
            'showCompanyBtn': {
                type: Boolean,
                default: () => false
            }
        },
        mounted () {
            this.init(this.value)
        },
        destroyed () {
            window.jQuery(this.$refs.editor).summernote('reset')
        },
        computed: {
            toolbar () {
                var base = [
                    ['style', ['style']],
                    ['font', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
                    ['fonttype', ['fontname', 'fontsize', 'color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['picture', 'hr']],
                    ['custom', ['link', 'unlink']],
                    ['misc', ['codeview', 'fullscreen']]
                ]

                var lead = [
                    ['ldInfo', ['leadInfo']]
                ]
                var member = [
                    ['mbInfo', ['memberInfo']]
                ]
                var company = [
                    ['cmpInfo', ['companyInfo']]
                ]

                var actions = !this.showDealBtn ? base : union(base, lead)
                actions = !this.showMemberBtn ? actions : union(actions, member)
                actions = !this.showCompanyBtn ? actions : union(actions, company)

                return actions
            }
        },
        watch: {
            value (value) {
                if (this.editor.summernote('code') !== value)
                    this.editor.summernote('code', value)
            }
        },
        methods: {
            init (value) {
                SummernoteImageAttributes()
                var vm = this

                this.editor = window.jQuery(this.$refs.editor)
                    .summernote({
                        disableDragAndDrop: true,
                        fontNames: ['Arial', 'Arial Black', 'Calibri', 'Courier New', 'Helvetica', 'Tahoma', 'Verdana'],
                        dialogsInBody: true,
                        toolbar: vm.toolbar,
                        buttons: {
                            leadInfo: this.leadInfo,
                            memberInfo: this.memberInfo,
                            companyInfo: this.companyInfo
                        },
                        codemirror: {
                            theme: 'monokai'
                        },
                        callbacks: {
                            onChange: (contents) => {
                                vm.$emit('input', contents)
                            }
                        },
                        popover: {
                            image: [
                                ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
                                ['float', ['floatLeft', 'floatRight', 'floatNone']],
                                ['custom', ['imageAttributes', 'unlink']],
                                ['remove', ['removeMedia']]
                            ],
                            link: [
                                ['link', ['linkDialogShow', 'unlink']]
                            ]
                        },
                        lang: 'en-US', // Change to your chosen language
                        imageAttributes: {
                            imageDialogLayout: 'default', // default|horizontal
                            icon: '<i class="note-icon-pencil"/>',
                            removeEmpty: false // true = remove attributes | false = leave empty if present
                        },
                        displayFields: {
                            imageBasic: true,  // show/hide Title, Source, Alt fields
                            imageExtra: false, // show/hide Alt, Class, Style, Role fields
                            linkBasic: true,   // show/hide URL and Target fields for link
                            linkExtra: false   // show/hide Class, Rel, Role fields for link
                        }
                    })

                this.editor.summernote('code', value)
            },
            formButton (items, label, icon, context) {
                let ui = window.jQuery.summernote.ui
                let list = []
                for (let item of items)
                    list.push({ key: trans(item), value: ('{' + label + item + '}').toUpperCase() })

                let options = ''
                list.forEach((item) => {
                    options += '<li><a href="#" data-value="' + item.value + '">' + item.key + '</a></li>'
                })
                let button = ui.buttonGroup([
                    ui.button({
                        className: 'dropdown-toggle',
                        contents: '<span class="' + icon + '"></span> ' + trans(label + 'info') + ' <span class="caret"></span>',
                        tooltip: trans(label + 'info'),
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    ui.dropdown({
                        className: 'drop-default summernote-list',
                        contents: options,
                        callback: function ($dropdown) {
                            $dropdown.find('li a').each(function () {
                                window.jQuery(this).on('click', function (e) {
                                    e.preventDefault()
                                    context.invoke('editor.insertText', window.jQuery(this).data('value'))
                                })
                            })
                        }
                    })
                ])
                return button
            },
            leadInfo (context) {
                let list = [
                    'first_name',
                    'last_name',
                    'reference',
                    'email',
                    'phone',
                    'mobile',
                    'dob',
                    'address',
                    'complement',
                    'district',
                    'zip_code',
                    'city',
                    'state',
                    'gender'
                ]
                let label = 'lead_'
                let icon = 'fa fa-user m-r-5'

                return this.formButton(list, label, icon, context).render()
            },
            memberInfo (context) {
                let list = [
                    'first_name',
                    'last_name',
                    'name_email_sender',
                    'email',
                    'email_signature',
                    'phone',
                    'mobile'
                ]
                let label = 'consultant_'
                let icon = 'fa-fw md-headset-mic m-r-5'

                return this.formButton(list, label, icon, context).render()
            },
            companyInfo (context) {
                var list = [
                    'name',
                    'fancy_name',
                    'email',
                    'phone',
                    'address',
                    'complement',
                    'district',
                    'zip_code',
                    'city',
                    'state'
                ]
                let label = 'company_'
                let icon = 'fa-fw fa fa-briefcase m-r-5'

                return this.formButton(list, label, icon, context).render()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/Summernote.vue